// extracted by mini-css-extract-plugin
export default {"notification":"ScheduledRedirectNotice-module__notification--q5clf"};